/* import __COLOCATED_TEMPLATE__ from './bypass-capacitors-container.hbs'; */
import Component from '@glimmer/component';

interface BypassCapacitorsContainerArgs {
  bypassCapacitors: Array<CapacitorItem>;
  adjustForReferences: boolean;
}

export type CapacitorItem = {
  item: string;
  value: string;
  tolerance: string;
  voltage: string;
  circuit: string;
};

export default class BypassCapacitorsContainer extends Component<BypassCapacitorsContainerArgs> {
  get xTranslate(): number {
    return this.args.adjustForReferences ? 525 : 5;
  }
}
